import React from 'react';
import SubNav from '../components/subNav';
import SEO from '../components/SEO';
import { baseUrl } from '../config';



const PromotionsPage = () => {
  return (
    <>
    <SEO
      title="Promotions Dashboard"
      description="Plan and execute your film's promotional strategy across social media, press, and digital channels with ProducerBuddy."
      url="https://producerbuddy.pilomation.com/promotions-page"
      robots="noindex, nofollow"
    />
    <SubNav/>
    <div className="bg-white min-h-screen p-8">
      <header className="text-center mb-8">
        <h1 className="text-4xl font-bold text-gray-800">AI-Driven Promotions for Your Production</h1>
        <p className="text-gray-600 mt-4">
          Leverage the power of AI to create stunning posters, trailers, and advertisements for your production.
        </p>
      </header>

      <section className="bg-white rounded-lg p-6 mb-8">
        <h2 className="text-2xl font-bold text-gray-700 mb-4">AI-Powered Poster Generation</h2>
        <p className="text-gray-600 mb-4">
          Our AI-driven tool analyzes the themes, tone, and characters of your production to generate visually
          captivating posters. Whether it’s a blockbuster movie, a short film, or a documentary, our AI designs
          posters tailored to your project's unique style and vision.
        </p>
        <img src="/images/poster-sample.jpg" alt="Sample Poster" className="w-full h-auto rounded-lg shadow-md" />
      </section>

      <section className="bg-white rounded-lg p-6 mb-8">
        <h2 className="text-2xl font-bold text-gray-700 mb-4">AI-Crafted Trailers</h2>
        <p className="text-gray-600 mb-4">
          Generate engaging trailers that captivate your audience. Our AI analyzes key scenes and creates a storyline
          to build compelling trailers that showcase the essence of your production.
        </p>
        <div className="aspect-w-16 aspect-h-9">
          <iframe
            src="https://www.youtube.com/embed/sample"
            title="AI-Crafted Trailer"
            className="rounded-lg shadow-md"
            allowFullScreen
          ></iframe>
        </div>
      </section>

      <section className="bg-white rounded-lg p-6 mb-8">
        <h2 className="text-2xl font-bold text-gray-700 mb-4">AI-Generated Advertisements</h2>
        <p className="text-gray-600 mb-4">
          Our AI-powered ad generator creates tailored marketing materials for your production. From social media ads
          to billboards, we ensure your production reaches the right audience with engaging content.
        </p>
        <img src="/images/ad-sample.jpg" alt="Sample Ad" className="w-full h-auto rounded-lg shadow-md" />
      </section>

      <footer className="text-center mt-12">
        <a href="#" className="bg-blue-600 text-white px-6 py-3 rounded-lg shadow-lg hover:bg-blue-500 transition">
          Get Started with AI Promotions
        </a>
      </footer>
    </div>
    </>
  );
};

export default PromotionsPage;

